(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-slide]')];
    const controls = root.querySelector('.slideshow-controls');
    const count = root.querySelector('[data-slide-count]');
    const pause = root.querySelector('[data-slide-pause]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, paused = reducedMotion.matches, hovering = false, focused = false, timer;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      count.textContent = `${index + 1} / ${slides.length}`;
    };
    const schedule = () => {
      clearInterval(timer);
      if (!paused && !hovering && !focused && !document.hidden) timer = setInterval(() => show(index + 1), 5000);
    };
    const updatePause = () => {
      pause.textContent = paused ? 'Play' : 'Pause';
      pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      schedule();
    };
    root.querySelector('[data-slide-prev]').addEventListener('click', () => { show(index - 1); schedule(); });
    root.querySelector('[data-slide-next]').addEventListener('click', () => { show(index + 1); schedule(); });
    pause.addEventListener('click', () => { paused = !paused; updatePause(); });
    root.addEventListener('mouseenter', () => { hovering = true; schedule(); });
    root.addEventListener('mouseleave', () => { hovering = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; schedule(); });
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    reducedMotion.addEventListener('change', event => { if (event.matches) { paused = true; updatePause(); } });
    controls.hidden = false;
    show(0);
    updatePause();
  }
  const initAll = () => document.querySelectorAll('[data-slideshow]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
